import { Box, Typography } from "@material-ui/core";
import { FC } from "react";
import { AppResource } from "../../../../types/resource.types";
import { ReservationStatus } from "../types";

const CanceledBy: FC<any> = (props) => {
  const reservation = props.record;

  return (
    <>
      {reservation.status === ReservationStatus.canceled ? (
        <Box>
          {" "}
          <Typography>
            {reservation.canceledBy.path.split("/")[0] === AppResource.coaches ? "By Me" : "By Client"}
          </Typography>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};

export default CanceledBy;
